import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledList } from './List.styled';
import { ListItem } from './ListItem';
function _List(_ref) {
  var onItemClicked = _ref.onItemClicked,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$nestedLevel = _ref.nestedLevel,
    nestedLevel = _ref$nestedLevel === void 0 ? 0 : _ref$nestedLevel;
  return /*#__PURE__*/React.createElement(StyledList, {
    onClick: onItemClicked
  }, items.map(function (item, i) {
    return !!item && /*#__PURE__*/React.createElement(ListItem, _extends({
      key: i
    }, item, {
      nestedLevel: nestedLevel,
      List: function List(props) {
        return /*#__PURE__*/React.createElement(_List, _extends({}, props, {
          nestedLevel: nestedLevel + 1
        }));
      }
    }));
  }));
}
export { _List as List };